import { useMemo } from "react";

import { ConciliationCaseJustification } from "@/@types/conciliation-history";

import { JustificationNames } from "../types";

export function useJustificationNames(
  justifications: readonly ConciliationCaseJustification[] | undefined
): JustificationNames {
  return useMemo((): JustificationNames => {
    const names: Record<string, string> = {};

    (justifications ?? []).forEach(
      (justification: ConciliationCaseJustification): void => {
        names[String(justification.id)] = justification.name;
      }
    );

    return names;
  }, [justifications]);
}
